import { createContext, ReactNode, useCallback, useContext, useRef } from 'react'
import { logFactory } from '../../util'

interface Props {
  children: ReactNode
}

interface ClickTrackingContext {
  readClickCount: () => number
  reset: () => void
}

const log = logFactory('hooks', 'useClickTracking')

const context = createContext<ClickTrackingContext>({
  readClickCount: () => 0,
  reset: () => undefined,
})

const { Provider } = context

const useClickTracking = (): ClickTrackingContext => useContext(context)

const ClickTrackingProvider = ({ children }: Props) => {
  const ref = useRef<number>(0)
  const readClickCount = useCallback(() => ref.current, [])

  const reset = useCallback(() => {
    ref.current = 0
  }, [ref])

  const contextValue = { readClickCount, reset }

  const onClick = () => {
    const updatedCount = ref.current + 1

    log(`🖱️ Click tracked`, updatedCount)
    ref.current = updatedCount
  }

  return (
    <Provider value={contextValue}>
      <div onClick={onClick}>{children}</div>
    </Provider>
  )
}

export { ClickTrackingProvider, useClickTracking }
